<template>
  <b-row class="m-0">
    <b-col cols="12">
      <b-row class="m-0 mb-3">
        <b-col class="p-0">
            <b-row class="m-0">
              <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
                  <font-awesome-icon icon="road" class="h2 mb-0" />
              </b-col>
              <b-col class="p-3 bg-facebook text-white d-flex align-items-center cursor-pointer" title="Click to select Project" @click="project_modal=true">
                  <div>
                  <h4 class="mb-0"><strong>{{settings.server_project_location_structure_item.project_location_structure.project_location.project.title}}</strong></h4>
                  <small class="text-muted text-uppercase font-weight-bold">PROJECT TITLE | Click to select Project</small>
                  </div>
              </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" class="loader" v-if="is_saving">
            <b-col>
              <b-spinner></b-spinner>
              <br><br>
              <strong>Loading</strong>
            </b-col>
          </b-row>
          <b-row>
        <b-col cols="4">
          <b-row class="m-0 mb-3">
            <b-col class="p-0">
                <b-row class="m-0">
                  <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                      <font-awesome-icon icon="calendar" class="h2 mb-0" />
                  </b-col>
                  <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                      <div>
                      <h4 class="mb-0"><strong>{{date}}</strong></h4>
                      <small class="text-muted text-uppercase font-weight-bold">DATE</small>
                      </div>
                  </b-col>
              </b-row>
            </b-col>
          </b-row>
          
          <b-row class="m-0 mb-3">
            <b-col class="p-0">
                <b-row class="m-0">
                  <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                      <font-awesome-icon icon="clock" class="h2 mb-0" />
                  </b-col>
                  <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                      <div class="text-center w-100">
                        <vue-clock />
                      </div>
                  </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="4" class=" custom-background-blue p-3">
          <div v-if="isCameraOpen" class="camera-box">

            <video v-show="!isPhotoTaken" ref="camera"  autoplay width="100%"></video>

            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="650" :height="537.5"></canvas>
          </div>
        </b-col>
        <b-col cols="4">
          <b-form @submit.prevent="takePhoto">
            <b-row class="m-0 mb-3">
            <b-col class="p-0">
                <b-row class="m-0">
                  <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                      <font-awesome-icon icon="qrcode" class="h2 mb-0" />
                  </b-col>
                  <b-col class="p-3 bg-success text-white d-flex align-items-center">
                      <div class="w-100">
                        <b-form-input
                                v-model="form.id_number"
                                type="password"
                                id="id_number"
                                autofocus
                                required
                                autocomplete="off"
                        ></b-form-input>
                      <small class="text-white text-uppercase font-weight-bold">SCAN YOUR QR</small>
                      </div>
                  </b-col>
              </b-row>
            </b-col>
          </b-row>
          </b-form>
          <div class="text-left mt-2" v-if="typeof settings.server_project_location_structure_item.project_location_structure!='undefined'">

            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings.server_project_location_structure_item.project_location_structure.project_location.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">LOCATION</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings.server_project_location_structure_item.project_location_structure.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">STRUCTURE</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings.server_project_location_structure_item.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">ITEM</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
            
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center bg-warning cursor-pointer" @click="changeSettings()">
                        <div>
                        <h4 class="mb-0"><strong>{{settings.mode_description}}</strong></h4>
                        <small class="text-uppercase font-weight-bold">CLICK TO CHANGE MODE / ITEM</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <!--<img :src="captured_image" >-->
      <b-row class="mt-3">
        <b-col>
          <server-side-paginated-table
              :fields="table_settings.fields"
              :api_url="table_settings.api_url"
              :delete_url="table_settings.delete_url"
              ref="displayTable"
              :top_right_btn_redirect="false"
            />
        </b-col>
      </b-row>
    </b-col>

    <b-modal
            v-model="settings_modal"
            centered
            size="lg"
            body-class="p-0"
            :hide-footer="true"
            :hide-header="true"
    >
      <div class="card mb-0">
        <div
                class="card-header bg-dark text-white d-flex align-items-center justify-content-between"
        >
          <h6 class="mb-0">
            Change Settings
          </h6>
        </div>
        <div class="card-body position-relative">
          <div class="bg-light mb-4 cursor-pointer" @click="changeProject()" v-if="settings_modal">
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings_form.server_project_location_structure_item.project_location_structure.project_location.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">LOCATION</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings_form.server_project_location_structure_item.project_location_structure.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">STRUCTURE</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="2" class="text-center p-2 bg-facebook text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="check" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 text-white d-flex align-items-center custom-background-blue">
                        <div>
                        <h4 class="mb-0"><strong>{{settings_form.server_project_location_structure_item.description}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">ITEM</small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

          <b-form-group label="Mode:" description="This field is required">
            <select class="form-control form-control-sm" v-model="settings_form.mode" required>
              <option value="1">AM IN</option>
              <option value="2">AM OUT</option>
              <option value="3">PM IN</option>
              <option value="4">PM OUT</option>
              <option value="5">OT IN</option>
              <option value="6">OT OUT</option>
            </select>
          </b-form-group>


          <b-button size="sm" block variant="success" @click="save_settings_modal=true"><font-awesome-icon icon="save" /> Save Settings</b-button>

        </div>
      </div>
    </b-modal>


    <b-modal
            v-model="projects_modal"
            centered
            size="xl"
            body-class="p-0"
            :hide-footer="true"
            :hide-header="true"
    >
      <div class="card mb-0">
        <div
                class="card-header bg-dark text-white d-flex align-items-center justify-content-between"
        >
          <h6 class="mb-0">
            Select Project
          </h6>
        </div>
        <div class="card-body position-relative">
          <b-input-group prepend="Search">
            <b-form-input v-model="project_search" placeholder="Type your keyword here..." autocomplete="off" debounce="500"></b-form-input>
          </b-input-group>
          <table class="table table-bordered mt-3 ta">
            <thead>
            <tr>
              <th>Location</th>
              <th>Structure</th>
              <th>Item</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="project_item in project_items" class="cursor-pointer" @dblclick="selectProject(project_item)">
              <td>{{project_item.location_description}}</td>
              <td>{{project_item.structure_description}}</td>
              <td>{{project_item.item_description}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <b-modal
            v-model="save_settings_modal"
            centered
            size="md"
            body-class="p-0"
            :hide-footer="true"
            :hide-header="true"
    >
      <div class="card mb-0">
        <div
                class="card-header bg-dark text-white d-flex align-items-center justify-content-between"
        >
          <h6 class="mb-0">
            SCAN YOUR QR
          </h6>
        </div>
        <div class="card-body position-relative">

          <b-form @submit.prevent="saveSettings">
            <h4 class="mt-2">Please scan a Timekeeper ID</h4>

            <b-form-input
                    v-model="settings_form.password"
                    type="password"
                    autofocus
                    required
                    autocomplete="off"
            ></b-form-input>
          </b-form>
          <img :src="assets_path.DEFAULT_URL+'qr.png'" class="w-100" />
        </div>
      </div>
    </b-modal>
    <b-modal
            v-model="project_modal"
            centered
            size="lg"
            body-class="p-0"
            :hide-footer="true"
            :hide-header="true"
    >
      <div class="card mb-0">
        <div
                class="card-header bg-dark text-white d-flex align-items-center justify-content-between"
        >
          <h6 class="mb-0">
            Please select a project
          </h6>
        </div>
        <div class="card-body position-relative">
          <template v-for="project in all_projects">
            <b-row class="m-0 mb-3">
              <b-col class="p-0">
                  <b-row class="m-0">
                    <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
                        <font-awesome-icon icon="road" class="h2 mb-0" />
                    </b-col>
                    <b-col class="p-3 bg-facebook text-white d-flex align-items-center cursor-pointer" title="Select this Project" @click="setProjectAsDefault(project.project_id)">
                        <div>
                        <h4 class="mb-0"><strong>{{project.server_project_location_structure_item.project_location_structure.project_location.project.title}}</strong></h4>
                        <small class="text-muted text-uppercase font-weight-bold">PROJECT TITLE <template v-if="project.is_default==1">| <b-badge variant="success">ACTIVE</b-badge></template></small>
                        </div>
                    </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </div>
      </div>
    </b-modal>
  </b-row>

</template>

<script>
    import {client_details,assets_path} from '@/config';
    import Loading from '@/views/widgets/Loading.vue';
    import VueClock from '@dangvanthanh/vue-clock';
    import SwalMixin from '@/views/mixins/Swal.js'
    import ServerSidePaginatedTable from './ServerSidePaginatedTable.vue';
    export default {
        name: 'Login',
        mixins:[SwalMixin],
        components: {Loading,VueClock,ServerSidePaginatedTable},
        data(){
            return{
              table_settings:{
                api_url:'site-timelog-logs/recent',
                delete_url:'roles/delete',
                fields:[
                  {key: 'id_number', label:'ID Number'},
                  {key: 'am_in', label:'AM IN'},
                  {key: 'am_out', label:'AM OUT'},
                  {key: 'pm_in', label:'PM IN'},
                  {key: 'pm_out', label:'PM OUT'},
                  {key: 'ot_in', label:'OT IN'},
                  {key: 'ot_out', label:'OT OUT'},
                ]
              },
              form:{
                id_number:'',
                image:''
              },
              settings_form:{
                server_project_location_structure_item_id:'',
                mode:1,
                server_project_location_structure_item:{},
                password:''
              },
              date:'',
              isCameraOpen: false,
              isPhotoTaken: false,
              isShotPhoto: false,
              isLoading: false,
              link: '#',
              captured_image:'',
              settings:{
                server_project_location_structure_item:{
                  project_location_structure:{
                    project_location:{
                      project:{
                        title:''
                      }
                    }
                  }
                }
              },
              settings_modal:false,
              projects_modal:false,
                save_settings_modal:false,
              project_search:'',
              project_items:[],
              assets_path:{},
              project_modal:false,
              all_projects:[],
              is_saving:false
            }
        },
      watch:{
        project_search:{
          immediate: true,
          deep:true,
          handler(){

            this.axios.get('project/location/structure/items/search-by-project',{params:{search:this.project_search}}).then(response => {
              this.project_items=response.data;
            }).catch(error => console.log(error));

          }
        },
      },
        created() {
          this.assets_path = assets_path;
          this.toggleCamera();
          let today = new Date();
          this.date = today.toDateString();
          this.getSettings();
        },
        methods:{
          toggleCamera() {
            if(this.isCameraOpen) {
              this.isCameraOpen = false;
              this.isPhotoTaken = false;
              this.isShotPhoto = false;
              this.stopCameraStream();
            } else {
              this.isCameraOpen = true;
              this.createCameraElement();
            }
          },

          createCameraElement() {
            this.isLoading = true;

            const constraints = (window.constraints = {
              audio: false,
              video: true
            });


            navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(stream => {
                      this.isLoading = false;
                      this.$refs.camera.srcObject = stream;
                    })
                    .catch(error => {
                      this.isLoading = false;
                      alert("May the browser didn't support or there is some errors.");
                    });
          },

          stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

            tracks.forEach(track => {
              track.stop();
            });
          },

          takePhoto() {
            let today = new Date();
            const context = this.$refs.canvas.getContext('2d');
            context.fillStyle = "yellow";
            context.drawImage(this.$refs.camera, 0, 0, 650, 537.5);
            context.fillText(today, 10, 520);

            //const download = document.getElementById("downloadPhoto");
            const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg");
            this.captured_image = canvas;
            this.form.image = canvas;
            this.axios.post('site-timelog-logs/save',this.form).then(response => {
              this.$refs.displayTable.getAll();
              this.swalTransactionCompleted();
              this.form.id_number='';


            }).catch(error => {
              this.swal_transaction_error_data.text = error.response.data;
              this.swalRequestError();
              this.form.id_number='';
              //this.is_saving=false;
            });
          },

          downloadImage() {
            const download = document.getElementById("downloadPhoto");
            const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                    .replace("image/jpeg", "image/octet-stream");
            download.setAttribute("href", canvas);
          },
          getSettings(){
            this.is_saving=true;
            this.axios.get('site-timelog-settings/get').then(response => {
              if(response.data.active_project!=null)
              {
                this.settings=response.data.active_project;
                this.settings_form.server_project_location_structure_item = response.data.active_project.server_project_location_structure_item;
                this.settings_form.server_project_location_structure_item_id=response.data.active_project.server_project_location_structure_item_id;
                this.is_saving=false;
              }

              this.all_projects=response.data.all_projects;
            }).catch(error => console.log(error));
          },
          changeSettings(){
            this.settings_modal=true;

          },
          changeProject(){
            this.projects_modal=true;
          },
          selectProject(item){
            this.settings_form.server_project_location_structure_item_id = item.id;
            this.settings_form.server_project_location_structure_item.project_location_structure.project_location.description = item.location_description;
            this.settings_form.server_project_location_structure_item.project_location_structure.description = item.structure_description;
            this.settings_form.server_project_location_structure_item.description = item.item_description;
            this.projects_modal=false;
          },
          saveSettings(){
            this.axios.post('site-timelog-settings/save',this.settings_form).then(response => {
              this.swalTransactionCompleted();
              this.save_settings_modal=false;
              this.settings_modal=false;
              this.getSettings();
            }).catch(error => {
              this.swal_transaction_error_data.text = error.response.data;
              this.swalRequestError();
              //this.is_saving=false;
            });
          },
          setProjectAsDefault(project_id){
            this.swalConfirmSubmit((data) => {
            if (data.value) {
              this.is_saving=true;
              this.axios.post('site-timelog-logs/set-project-as-default',{project_id:project_id}).then(response => {
                this.swalTransactionCompleted();
                this.project_modal=false;
                this.getSettings();
              }).catch(error => {
                this.swal_transaction_error_data.text = error.response.data;
                this.swalRequestError();
                this.is_saving=false;
              });
            }
          });
          }
        }
    }
</script>
<style>
body{
  line-height: 1 !important;
}
</style>
